export default __webpack_public_path__ + "static/media/handshake.2860a1ec.svg";